// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1r2RH","colMin":"styles_colMin__1hVQZ"};